import { Flex } from "@chakra-ui/react"
import { withPrefix } from "gatsby"
import React from "react"
import { useImagePicker } from "../desktop/hooks/useImagePicker"
import { useCloudProviderContext } from "../hooks/useCloudProviderContext"
import CloudProviderSelectionButton from "./CloudProviderSelectionButton"

interface Props {}

const CloudBrowserSidebar: React.FC<Props> = () => {
  const {
    setCurrentCloudProvider,
    currentCloudProvider,
    imageRegionId,
    lineItemId,
    productId,
    closeCloudProviderModal,
    setIsImportingImages,
  } = useCloudProviderContext()

  const onStartImporting = () => {
    setIsImportingImages(true)
  }

  const onCompleteImporting = () => {
    setIsImportingImages(false)
    closeCloudProviderModal()
  }

  const { getInputProps, openImagePicker } = useImagePicker({
    onCompleteImporting,
    onStartImporting,
    imageRegionId,
    lineItemId,
    productId,
  })

  return (
    <Flex flexDirection="column" flex={1} p={6} gap={2}>
      <>
        <CloudProviderSelectionButton
          logo={withPrefix("/images/cloud-providers/desktop/desktop.svg")}
          label="Your Device"
          isSelected={currentCloudProvider === "your-device"}
          onClick={() => {
            setCurrentCloudProvider("your-device")
            openImagePicker()
          }}
        />
        <input {...getInputProps()} />
      </>
      <CloudProviderSelectionButton
        logo={withPrefix("/images/cloud-providers/vnz/ic_verizon-v.svg")}
        label="Verizon Cloud"
        isSelected={currentCloudProvider === "verizon-cloud"}
        onClick={() => setCurrentCloudProvider("verizon-cloud")}
      />
    </Flex>
  )
}

export default CloudBrowserSidebar
